import React from 'react';
import DonutSplitChart from './DonutSplitChart';

const CategorySplitChart = () => (
  <DonutSplitChart
    title="Split Over Category"
    endpoint="/dashboard/category-split"
    fixedCategories={[{ name: 'Medium' }, { name: 'Micro' }, { name: 'Small' }]}
    cornerLabel="count · %"
  />
);

export default CategorySplitChart;
